var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/character/".concat(_vm.character.m_CharaID)
    }
  }, [_vm.collection ? [_c('v-list-item-avatar', {
    attrs: {
      "size": "48"
    }
  }, [_c('CharaIcon', {
    attrs: {
      "id": _vm.id,
      "size": 48
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.character.m_Name)))]), !_vm.$s.characterIconFramed ? _c('v-list-item-subtitle', {
    staticClass: "d-flex align-center"
  }, [_vm._l(_vm.character.m_Rare + 1, function (i) {
    return _c('img', {
      key: "rare-icon-".concat(i),
      staticClass: "d-inline",
      attrs: {
        "width": 48 / 4,
        "height": 48 / 4,
        "src": _vm.$asset.commonuiatlas.format('RareIcon') + '.png'
      }
    });
  }), _c('span', {
    staticClass: "pr-1"
  }), _c('img', {
    attrs: {
      "width": 48 / 2.5,
      "height": 48 / 2.5,
      "src": _vm.$asset.commonuiatlas.format(_vm.classIcon) + '.png'
    }
  }), _c('span', {
    staticClass: "pr-1"
  }), _c('img', {
    attrs: {
      "width": 48 / 2.5,
      "height": 48 / 2.5,
      "src": _vm.$asset.commonuiatlas.format(_vm.elementIcon) + '.png'
    }
  })], 2) : _vm._e()], 1)] : [_c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('CharaIcon', {
    attrs: {
      "id": _vm.id,
      "size": _vm.$size()
    }
  })], 1), _c('v-list-item-content', {
    staticClass: "mr-auto ml-0",
    staticStyle: {
      "max-width": "384px"
    }
  }, [_c('v-list-item-title', {
    staticClass: "d-flex align-center"
  }, [!_vm.$s.characterIconFramed ? [_vm._l(_vm.character.m_Rare + 1, function (i) {
    return _c('img', {
      key: "rare-icon-".concat(i),
      staticClass: "d-inline",
      attrs: {
        "width": _vm.$size() / 4,
        "height": _vm.$size() / 4,
        "src": _vm.$asset.commonuiatlas.format('RareIcon') + '.png'
      }
    });
  }), _c('span', {
    staticClass: "pr-1"
  }), _c('img', {
    attrs: {
      "width": _vm.$size() / 2.5,
      "height": _vm.$size() / 2.5,
      "src": _vm.$asset.commonuiatlas.format(_vm.classIcon) + '.png'
    }
  }), _c('span', {
    staticClass: "pr-1"
  }), _c('img', {
    attrs: {
      "width": _vm.$size() / 2.5,
      "height": _vm.$size() / 2.5,
      "src": _vm.$asset.commonuiatlas.format(_vm.elementIcon) + '.png'
    }
  }), _c('span', {
    staticClass: "pr-1"
  })] : _vm._e(), _vm._v(_vm._s(_vm.$name(_vm.character.m_Name)))], 2), _c('v-list-item-subtitle', [_c('Status', {
    attrs: {
      "status": _vm.status,
      "divide": "3"
    }
  })], 1)], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }